class ThcImageSlider extends HTMLElement {
  #swiper = null;
  connectedCallback() {
    this.#init();
  }
  #init() {
    this.#swiper?.destroy(true, true);
    const nextEl = this.querySelector(".swiper-button-next");
    const prevEl = this.querySelector(".swiper-button-prev");
    const paginationEl = this.querySelector(".swiper-pagination");

    this.#swiper = new Swiper(this.querySelector(".swiper"), {
      loop: false,
      speed: 500,
      slidesPerView: "auto",
      spaceBetween: 12,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      touchRatio: 1,
      touchAngle: 45,
      breakpoints: {
        768: {
          spaceBetween: 25,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
      },
    });
    console.log(this.#swiper);
  }
}
if (!customElements.get("thc-image-slider")) {
  customElements.define("thc-image-slider", ThcImageSlider);
}
